export enum TextEditorFeature {
  UndoRedo = 'undoRedo',
  CharacterCounter = 'characterCounter',
  EmojiPicker = 'emojiPicker',
  PageMention = 'pageMention',
  UserMention = 'userMention',
  DirectMention = 'directMention',
  HashtagsPresets = 'hashtagsPresets',
  LinkShortener = 'linkShortener',
  FileAttachments = 'fileAttachments',
  AIContent = 'aiContent',
  AIHashtags = 'aiHashtags',
  Translation = 'translation',
  ParseLink = 'parseLink',
}

export type TextEditorFeatures = TextEditorFeature[];

export const DEFAULT_TEXT_EDITOR_FEATURES = [
  TextEditorFeature.UndoRedo,
  TextEditorFeature.CharacterCounter,
  TextEditorFeature.EmojiPicker,
  TextEditorFeature.PageMention,
  TextEditorFeature.DirectMention,
  TextEditorFeature.HashtagsPresets,
  TextEditorFeature.LinkShortener,
  TextEditorFeature.AIContent,
  TextEditorFeature.AIHashtags,
];

export const TEXT_EDITOR_SUGGESTIONS_QUERY_START_LENGTH = 3;

/**
 * Minimum query for the Instagram location picker. Mirrors the api's own
 * `min:3` on `mentions/locations` — below it no request is made, so the picker
 * must not report on a search that never ran.
 */
export const LOCATION_QUERY_MIN_LENGTH = 3;
export const TEXT_EDITOR_SUGGESTIONS_DEBOUNCE_DELAY = 500;
